import CourseAbsence from './CourseAbsence';

export default CourseAbsence;